import useSWR, { mutate as globalMutate } from "swr";
import { API } from "../utils/constants";
import { authFetcher } from "./fetcher";

/**
 * useAdminCategories — Fetches all admin categories including inactive.
 *
 * API: GET /api/admin/categories → AdminCategoryDto[] (CON-002 §7)
 * Requires Bearer token.
 *
 * @returns {{ categories: Array, error: any, isLoading: boolean, mutate: Function }}
 */
export function useAdminCategories() {
  const { data, error, isLoading, mutate } = useSWR(
    API.ADMIN.CATEGORIES.LIST,
    authFetcher,
    { revalidateOnFocus: false }
  );

  return { categories: data ?? [], error, isLoading, mutate };
}

/**
 * invalidateAdminCategories — Force-revalidates the admin categories SWR cache.
 */
export const invalidateAdminCategories = () =>
  globalMutate(API.ADMIN.CATEGORIES.LIST);
